<template>
  <div class="bb-tags">
    <div class="bb-tags-tabs">
      <template v-for="tab in tabsList">
        <div
          :key="tab.id"
          class="bb-tags-tabs__item"
          :class="{'bb-tags-tabs__item_active' : activeTab === tab.id}"
          @click="setActiveTab(tab)"
        >
          {{ tab.title }}
        </div>
      </template>
    </div>
    <div class="bb-tags-main">
      <ProjectListTags v-if="activeTab === projectTab"/>
      <ListOfRequestTags v-else-if="activeTab === requestsTab"/>
      <VendorsTags v-else/>
    </div>
  </div>
</template>

<script>
import VendorsTags from '@/components/Settings/Tags/VendorsTags/VendorsTags'
import {TAGS_TABS, TAGS_PROJECT_TAB_ID, TAGS_REQUESTS_TAB_ID} from '@/constants/Tabs/Tags'
import ProjectListTags from '@/components/Settings/Tags/ProjectListTags/ProjectListTags'
import ListOfRequestTags from '@/components/Settings/Tags/ListOfRequestTags/ListOfRequestTags'

export default {
  name: 'Tags',
  components: {
    ProjectListTags,
    ListOfRequestTags,
    VendorsTags
  },
  data: () => ({
    projectTab: TAGS_PROJECT_TAB_ID,
    requestsTab: TAGS_REQUESTS_TAB_ID,
    activeTab: TAGS_PROJECT_TAB_ID,
    tabsList: TAGS_TABS
  }),
  methods: {
    setActiveTab ({id}) {
      this.activeTab = id
    }
  }
}
</script>

<style  lang="scss" scoped>
@import "../../../sass/variables";

  .bb-tags {
    margin: -10px -20px -10px -20px;
  }

  .bb-tags-main {
    height: calc(100vh - 120px);
    background: $color-white;
    padding: 30px 30px 30px 30px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .bb-tags-tabs {
    display: flex;
    align-items: center;
    width: 100%;
    height: 54px;
    background: $color-white;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin: 0 0 6px 0;

    &__item {
      padding: 18px 26px 18px 26px;
      color: $color-accent;
      font-size: 15px;
      font-weight: 600;
      line-height: 18px;
      position: relative;
      cursor: pointer;

      & + & {
        margin: 0 0 0 32px;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        border-radius: 3px 4px 0 0;
        background-color: $color-accent;
        transition: 0.3s;
        opacity: 0;
        height: 0;
      }

      &_active {
        pointer-events: none;

        &:after {
          opacity: 1;
          height: 3px;
        }
      }

      &:hover {
        &:after {
          background-color: $color-accent-hover;
          opacity: 1;
          height: 3px;
        }
      }
    }
  }

</style>

<style  lang="scss">

  .bb-tags {
    .bb-subsection-list {
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.12);
      margin: 20px 0 0 0;
      max-height: 306px;
      height: auto !important;
      border-radius: 5px;
    }
    .bb-list-body {
      margin-right: 0;
    }

    .bb-list-body-item {
      &:first-child {
        border-top: 0
      }
    }

    .bb-list-header {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Tags/Tags.vue